import { Button, Col, Form, Row, Space } from "antd";
import React, { useState } from "react";
import FormCheckbox from "./FormCheckbox";
import FormSelect from "./FormSelect";
import "./FormFilter.css";
import RateFormSelect from "./RateFormSelect";
import { IconAdjustmentsAlt, IconX } from "@tabler/icons-react";
import { useAppSelector } from "app/hooks";
import { FilterComment } from "features/comment/types/comment.type";

type Props = {
  defaultFilters: any;
  setFilters: React.Dispatch<React.SetStateAction<FilterComment>>;
  filters: FilterComment;
  className?: string;
  styleWrapper?: React.CSSProperties | undefined;
  is_time_type?: boolean;
  is_image?: boolean;
};
const FormFilter = (props: Props) => {
  const {
    setFilters,
    defaultFilters,
    className = "flex-1",
    styleWrapper,
    is_time_type,
    is_image,
    filters,
  } = props;

  const token = useAppSelector((state) => state.auth.token);
  /////
  const [form] = Form.useForm();

  /////
  const [errors, setErrors] = useState<string[]>([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [departmentLabel, setDepartmentLabel] = useState<any[]>([]);
  const [noFilters, setNoFilters] = useState<boolean>(true);
  const [isBlur, setIsBlur] = useState<boolean>(false);
  ////

  const handleValueChange = (changeValue: any, values: any) => {
    setIsBlur(true);
    form.submit();
  };

  const handleResetFilters = () => {
    form.resetFields();
    setNoFilters(true);
    setFilters({ ...defaultFilters });
  };

  const onSubmit = async (formData: any) => {
    setLoading(true);
    const NoValue = Object.values(formData).every(
      (i: any) => i === undefined || i === "" || i === null || i.length === 0
    );

    setNoFilters(NoValue);
    const newFormData = Object.entries(formData).filter((item) =>
      item.every(
        (items) =>
          items !== "" &&
          items !== undefined &&
          items !== "range_date" &&
          items !== "month"
      )
    );

    const paramFilter: any = Object.fromEntries(newFormData);
    // console.log("Param", paramFilter);

    if (NoValue) {
      setLoading(false);
      if (isBlur) {
        setFilters({
          ...defaultFilters,
        });
      }
      return;
    } else {
      setFilters({
        ...filters,
        ...paramFilter,
        sort_type: paramFilter.sort_by !== "date_created_asc" ? "DESC" : "ASC",
        sort_by:
          paramFilter.sort_by === "date_created_asc"
            ? "date_created"
            : paramFilter.sort_by,
      });
    }
    setLoading(false);
  };

  const [hasFilter, setHasFilter] = useState<boolean>(false);

  const styles = {
    height: "auto",
    maxHeight: 40,
  };
  const Columns: any = [
    // {
    //   name: "has_image",
    //   style: { ...styles },
    //   endpoint: {
    //     xs: 2,
    //     sm: 2,
    //     md: 2,
    //     lg: 2,
    //     xl: 2,
    //     default: 4,
    //   },
    //   is_show: is_image,
    //   children: <FormCheckbox>Có hình</FormCheckbox>,
    // },
    // {
    //   name: "no_image",
    //   style: { ...styles },
    //   endpoint: {
    //     xs: 2,
    //     sm: 2,
    //     md: 2,
    //     lg: 2,
    //     xl: 2,
    //     default: 4,
    //   },
    //   is_show: is_image,
    //   children: <FormCheckbox>Không hình</FormCheckbox>,
    // },
    // {
    //   name: "has_video",
    //   style: { ...styles },
    //   endpoint: {
    //     xs: 8,
    //     sm: 12,
    //     md: 8,
    //     lg: 12,
    //     xl: 3,
    //     default: 24,
    //   },
    //   is_show: is_image,
    //   children: <FormCheckbox>Video</FormCheckbox>,
    // },
    {
      name: "sort_by",
      style: { ...styles },
      endpoint: {
        xs: 12,
        sm: 12,
        md: 4,
        lg: 4,
        xl: 4,
        default: 12,
      },
      is_show: is_time_type,
      children: (
        <FormSelect
          className="m-0"
          name={"sort_by"}
          placeholder={"Lọc theo thời gian"}
          allowClear={true}
          options={[
            { value: "", label: "Tất cả" },
            { value: "date_created", label: "Bình luận mới nhất" },
            { value: "like", label: "Bình luận nhiều like nhất" },
            { value: "date_created_asc", label: "Bình luận cũ nhất" },
          ]}
        ></FormSelect>
      ),
    },
    {
      name: "rate",
      style: { ...styles },
      endpoint: {
        xs: 12,
        sm: 12,
        md: 4,
        lg: 4,
        xl: 4,
        default: 12,
      },
      is_show: is_time_type,
      children: (
        <RateFormSelect
          // style={{ backgroundColor: "#f7f7f7", border: "1px solid #d8d7d8" }}
          name="rate"
          className="m-0  form-select-wrapper"
          placeholder={"Lọc theo đánh giá"}
        ></RateFormSelect>
      ),
    },
    // {
    //   name: "onlyme",
    //   style: { ...styles },
    //   endpoint: {
    //     xs: 4,
    //     sm: 4,
    //     md: 4,
    //     lg: 4,
    //     xl: 4,
    //     default: 4,
    //   },
    //   is_show: token !== null,
    //   children: (
    //     <FormCheckbox
    //       onChange={(e) => {
    //         setFilters((prev: any) => {
    //           return { ...prev, onlyme: e.target.checked ? 1 : 0 };
    //         });
    //       }}
    //       // value={1}
    //     >
    //       Của tôi
    //     </FormCheckbox>
    //   ),
    // },
  ];
  return (
    <Space
      className={`formfilter_wrapper ${className}`}
      style={{ display: "block", flexBasis: "70%", ...styleWrapper }}
    >
      <Form
        initialValues={{}}
        // initialValues={{ department_id: 1222 }}
        onFinish={onSubmit}
        form={form}
        onValuesChange={handleValueChange}
        // submitText={isEditing ? t("common:form.save") : t("common:form.submit")}
      >
        <Row gutter={[8, 8]} align="stretch">
          {Columns.map((col: any, index: number) => {
            if (col.is_show) {
              if (col.name === "image") {
                return (
                  <Col
                    key={index}
                    style={{ height: "auto", maxHeight: 40 }}
                    span={col.endpoint.default}
                    xs={col.endpoint.xs}
                    sm={col.endpoint.sm}
                    md={col.endpoint.md}
                    lg={col.endpoint.md}
                    xl={col.endpoint.xl}
                  >
                    <Form.Item
                      name={col.name}
                      style={{ margin: 0 }}
                      valuePropName="checked"
                    >
                      {col.children}
                    </Form.Item>
                  </Col>
                );
              } else if (col.name === "onlyme") {
                return (
                  <Col
                    key={index}
                    style={{ height: "auto", maxHeight: 40 }}
                    span={col.endpoint.default}
                    xs={col.endpoint.xs}
                    sm={col.endpoint.sm}
                    md={col.endpoint.md}
                    lg={col.endpoint.md}
                    xl={col.endpoint.xl}
                  >
                    {col.children}
                  </Col>
                );
              } else {
                return (
                  <Col
                    key={index}
                    style={{ height: "auto", maxHeight: 40 }}
                    span={col.endpoint.default}
                    xs={col.endpoint.xs}
                    sm={col.endpoint.sm}
                    md={col.endpoint.md}
                    lg={col.endpoint.md}
                    xl={col.endpoint.xl}
                  >
                    <Form.Item name={col.name} style={{ margin: 0 }}>
                      {col.children}
                    </Form.Item>
                  </Col>
                );
              }
            }
            return <></>;
          })}
          {/* <Col style={{ height: "auto" }} xs={2} sm={2} xl={2}>
            <Form.Item style={{ margin: 0 }}>
              <Space style={{ display: "flex" }}>
                <Button
                  type="default"
                  className="h-full"
                  htmlType="submit"
                  loading={loading}
                  size="small"
                >
                  <IconAdjustmentsAlt></IconAdjustmentsAlt>
                </Button>

                {(hasFilter || !noFilters) && (
                  <Button
                    type="link"
                    danger
                    icon={<IconX size="16" className="mr-1 -mt-0.5" />}
                    onClick={() => handleResetFilters()}
                  >
                    reset
                  </Button>
                )}
              </Space>
            </Form.Item>
          </Col> */}
          {/* <Col span={24}></Col> */}
        </Row>
      </Form>
    </Space>
  );
};

export default FormFilter;
